import CancelablePromise from 'mn-utils/CancelablePromise';
import {getAccountDetails, getAccountList} from './mock';
import {TList, TResponse, TUUID} from '@/types';
import {TCreateParams, TDetails, TListItem, TListParams, TUpdateParams} from './types';
import {apiRequest} from '../../ws';
import {
  ENDPOINT_MERCHANT_BANKS_LIST,
  ENDPOINT_MERCHANT_BANK_DETAILS,
  ENDPOINT_MERCHANT_BANK_CREATE,
  ENDPOINT_MERCHANT_BANK_UPDATE,
  ENDPOINT_MERCHANT_BANK_SET_PRIMARY,
  ENDPOINT_MERCHANT_BANK_REMOVE
} from '../../../constants/api';

// Получить список банков
export function apiV2BankList(params: TListParams): Promise<TList<TListItem[]>> {
  const url = ENDPOINT_MERCHANT_BANKS_LIST;
  params = params || {};
  params.offset = params.offset || 0;
  params.limit = params.limit || 10;

  if (process.env.MOCK) {
    const response = {
      list: getAccountList(params.limit),
      count: params.limit * 10,
    };
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return apiRequest(url, params);
}

// Получить детали банка
export function apiV2BankDetails(params: {id: TUUID}): Promise<TDetails> {
  const url = ENDPOINT_MERCHANT_BANK_DETAILS;
  if (process.env.MOCK) {
    const response = getAccountDetails();
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return apiRequest(url, params);
}

// Добавить банк
export function apiV2BankCreate(params: TCreateParams): Promise<TResponse> {
  const url = ENDPOINT_MERCHANT_BANK_CREATE;
  if (process.env.MOCK) {
    const response = {status: 'SUCCESS'};
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return apiRequest(url, params);
}

// Обновить информацию по банку
export function apiV2BankUpdate(params: TUpdateParams): Promise<TResponse> {
  const url = ENDPOINT_MERCHANT_BANK_UPDATE;
  if (process.env.MOCK) {
    const response = {status: 'SUCCESS'};
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return apiRequest(url, params);
}

export function apiV2BankSetPrimary(params: TUpdateParams): Promise<TResponse> {
  const url = ENDPOINT_MERCHANT_BANK_SET_PRIMARY;
  if (process.env.MOCK) {
    const response = {status: 'SUCCESS'};
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return apiRequest(url, params);
}

// Удалить банк
export function apiV2BankDelete(params: {id: TUUID}): Promise<TResponse> {
  const url = ENDPOINT_MERCHANT_BANK_REMOVE;
  if (process.env.MOCK) {
    const response = {status: 'SUCCESS'};
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return apiRequest(url, params);
}
